"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const get_timezone_from_offset_1 = require("@src/backend/helpers/get-timezone-from-offset");
const elements_1 = require("@src/components/elements");
const normalize_string_1 = require("@src/helpers/normalize-string");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FullWidthSelect = (0, styled_components_1.default)(elements_1.Select) `
	width: 100%;
`;
const TimezoneSelect = (props) => {
    const { onChange, value, offset } = props;
    const allTimezoneNames = moment_timezone_1.default.tz.names().map(name => ({
        value: name,
        label: name,
    }));
    react_1.default.useEffect(() => {
        if (typeof offset === 'number') {
            const timezones = (0, get_timezone_from_offset_1.getOffsetTimezoneNames)(offset);
            onChange === null || onChange === void 0 ? void 0 : onChange((0, get_timezone_from_offset_1.getSingleTimezoneFromArray)(timezones));
        }
    }, [offset]);
    return ((0, jsx_runtime_1.jsx)(FullWidthSelect, { onChange: onChange, value: value, options: allTimezoneNames, optionFilterProp: "children", filterOption: (input, option) => (0, normalize_string_1.normalizeStr)(option.label).indexOf((0, normalize_string_1.normalizeStr)(input)) >= 0, showSearch: true }));
};
exports.TimezoneSelect = TimezoneSelect;
